import { useEffect } from 'react';
import { useAuthCompany } from '../context/AuthCompanyContext';

export const useNotificationDeepLink = () => {
  const { activeCompanyId, switchCompany, availableCompanies } = useAuthCompany();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const companyId = params.get('company_id');
    const taskId = params.get('task_id');

    if (!companyId) return;

    // Wait until availableCompanies is loaded before switching
    if (availableCompanies.length === 0) return;

    const isValidCompany = availableCompanies.some(c => c.companyId === companyId);
    if (!isValidCompany) return;

    if (companyId !== activeCompanyId) {
      switchCompany(companyId);
    }

    // Clean up URL params so refresh doesn't re-trigger
    const cleanUrl = window.location.pathname;
    window.history.replaceState({}, '', cleanUrl);

    // Optional: store taskId for navigation after switch
    if (taskId) {
      sessionStorage.setItem('pending_task_id', taskId);
    }
  }, [availableCompanies, activeCompanyId, switchCompany]);
};
